<script>
	export let param
	export let idOnPage

	import { createEventDispatcher, getContext } from 'svelte'

	const paramNameId = `${idOnPage}__Name`
	const paramValueId = `${idOnPage}__Value`

    const availableParams = getContext("experimentAvailableParams") 

	const dispatch = createEventDispatcher()

	$: pattern = availableParams[param.name]?.at(0) || "^\\d+$"
	$: placeholder = availableParams[param.name]?.at(1)?.toString() || "0"

	function updateName() {
		dispatch("nameChanged")
		setTimeout(() => {
			param.value = placeholder.toString()			
		}, 100);
	}

	function remove() {
		dispatch("remove")
	}
</script>

<div class="row">
	<div class="input-field col s6">
		<select id="{paramNameId}" bind:value={param.name} on:change="{updateName}">
			<option value="" disabled selected>Select parameter</option>
			{#each Object.keys(availableParams) as availableParam}
				<option value={availableParam}>{availableParam}</option>
			{/each}
		</select>
		<label for="{paramNameId}">Parameter</label>
	</div>
	<div class="input-field col s4">
		{#if pattern instanceof Array}
			<div> <!-- Add div to support DOM rebuilding -->
				<select id="{paramValueId}" bind:value={param.value}>
					{#each pattern as patternItem}
						<option value={patternItem.toString()}>{patternItem}</option>					
					{/each}
				</select>
				<label for="{paramValueId}">Value</label> <!-- Personal label for select to support DOM rebuilding -->
			</div>			
		{:else}
			<input id="{paramValueId}" type="text" pattern="{pattern}" placeholder="{placeholder}" required="{Boolean(param.name)}" class="validate" bind:value="{param.value}" />
			<label for="{paramValueId}">Value</label> <!-- Personal label for text input -->
		{/if}
	</div>
	<div class="col s2">
		<button class="btn-floating" on:click={remove}><i class="material-icons">clear</i></button>
	</div>
</div>

<style>	
</style>
